// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    name: 'Cu', 
    assetBaseUrl:'https://genaichatbotcuqa.blob.core.windows.net/chatbots/',
    oktaAuthService:'oidc.okta',
    clientId:'0oa28hfc7gm71FvtW0h8',
    issuer:'https://atge.oktapreview.com',
    // redirectUri:'http://localhost:4200/login/callback',
    redirectUri:'https://genai-dev.chamberlain.edu/login/callback',
    oktaSignoutRedirectUri: 'https://genai-dev.chamberlain.edu',
    studentAzureChatBotServiceFlag:true,
    studentGCPChatBotServiceFlag:true,
    studentAvaamoChatBotServiceFlag:true,
    chatbotName:'Ava',
    EnrollmentChatbotName: 'Ava',
    SASTokenForUnivercityLogo: 'sp=r&st=2024-11-19T13:36:45Z&se=2026-08-31T21:36:45Z&sv=2022-11-02&sr=b&sig=cx%2FdnOAT5Gkf%2Bu4%2FYGeBiGRm8UP%2FYynix1Q4JEKFfts%3D',
    SASTokenForChatbotIcon: 'sp=r&st=2024-11-07T08:48:35Z&se=2026-08-01T16:48:35Z&sv=2022-11-02&sr=b&sig=TEBmqQKsZSf0Eb79%2FD2mbktshxXIyLqWwf1s4d6ygqk%3D',
    SASTokenForFavicon: 'sp=r&st=2024-11-14T08:49:17Z&se=2026-09-01T16:49:17Z&sv=2022-11-02&sr=b&sig=iLDRZlvUfAeab0%2BTTtretZPUwTtn9VXMnIdmtlFBMNQ%3D',
    SASTokenForSudentAzureBot: 'sp=r&st=2024-11-29T13:27:20Z&se=2026-09-30T21:27:20Z&sv=2022-11-02&sr=b&sig=JBQ7wfBXapBq31%2FoNEBwBCscGlNi87YlKuY1lMJidI8%3D',
    studentChatbotName: 'Ava',
    chatbotIconForMessage: 'sp=r&st=2024-11-18T14:12:04Z&se=2026-08-31T22:12:04Z&sv=2022-11-02&sr=b&sig=pbcFGiTi7dlYksyI4p5xny9X8FiZmD1A0YIFrYTOTRw%3D',
    SASTokenForLogoutButton: 'sp=r&st=2024-12-06T07:01:56Z&se=2026-10-01T15:01:56Z&sv=2022-11-02&sr=b&sig=mD6%2BkQUKlhHy8SCXrX2FKiFNoWUv1PSE5rFjoTxvhxg%3D',
    apimConfigurationEnable: true,
    enrollmentRouteName: 'enrollmentcopilot',
    studentAzureRouteName: 'student-support-azure',
    studentbotRouteName: 'studentbot',
    faqConfigurationEnable: false,

    studentAsStaffConfig: {
      apimSubscriptionKeyForStd: '04b4e42ef33d4524960abfa0daf902b5',
      botApiUrl: "",
      chatUrl: '',
      channelId: 'fc607842-1410-40ce-963c-be569f63b2e0',
      cachedResponseConstant: 'Saved Student Response',
      chatBotIdStd: "",
      secretKey: "75b3a6e2-5996-44fa-8b9a-446d68201884",
    },

    enrollmentConfig: {
      apimSubscriptionKeyForEnr: '6b7099a521a64321acdff359389a47fd',
      cachedResponseConstant: 'Saved Enrollment Response',
      chatBotIdEnr: "",
      salesforceConfigUrl: "https://laureateone--dev.sandbox.lightning.force.com",
    },

    commonConfig: {
      acknowledgementAPI: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/acknowledgement",
      chatHistory: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/getChatHistory",
      citationPDF: "https://genaicopilotmmpdevblob.blob.core.windows.net/",
      citationPayloadLink: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/citationCategoryGrouping",
      convoAction: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/conversationAction",
      convoFeedback: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/conversationUserFeedback",
      getChatbotId: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/getChatbotID",
      refreshChat: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/refreshChatbot",
      sasCookies: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/pdfCitationAccessSASToken",
      sasToken: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/pdfCitationAccessSASToken",
      searchApiRequest: "https://api-dev.chamberlain.edu/cu-mmp-charlotte-chatbot-genai/1.0/searchAPI/",
      faqApi: "",
      publicKey: "LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF1UlJGQlR5UmEyV1A2QXdmUVpDUwpmaUFoaER0ZEpHd2Z5T2hOWll4Y2FuRlprNW04eWkwZjFSWXdQTUk2WFhJVWN1VWVydXEyeEp0a1FVdnNEcDNFCm5UNnhwaDNqTUNVa3VMNGVGa0VDczQ5VTNMSmN6WCtKNXZscWhaeHZmR25mTTNuTnVheXc3bFdjZU5ndXAyNXIKWnNmZEhCcDFwaUJJclhZNGlNYWFZZEhJQjhLTjRiUTFrN3VUaGJWUU9saE90Q1RDYzVManc4a25yN05xUmxaSwpjSEV4bUpXSmJya2RvakkraTBwUlBTY1VxN0ZpVTlwVlZoT01reXVObXdCOUlhQUc1OW5zQlBHWllaRlZZMWdVCllSM0pxQ1ROdmZyMVhCcXF6MmsxRC9VVkN6OWhLNlpWRjJETkJib3FNYnZzeFJnYWlXWGRZV2RuUmpOTVA2UUUKTHdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==",
      getFunctionKeyValidation: "https://genai-cu-dev-httptriggerfunctionapp.azurewebsites.net/api/get_okta_token?action=validate-key",
      functionKey: "R-WpW9MPVSrFOJLOeYVl-PIRvWCUWVPqho0WEEwZKbpqAzFuC7Zg_w=="
    }, 

    Question1:"What support services are available for Chamberlain students?",
    Question2:"How is Chamberlain's faculty different from other online universities?",
    Question3:"Can you tell me about Chamberlain's accreditation?"
};

(window as any).env = environment;


